import { getDeveloperToken } from 'services/tokenService'
import { createAxiosInstance } from 'api/axiosFactory'
import config from 'config'


const axiosInstance = () => {
  const axiosConfig = {
    baseURL: config.DEVELOPER_API_URL,
    headers: {'Authorization': `Bearer ${getDeveloperToken()}`}
  }
  return createAxiosInstance(axiosConfig)
}

export const fetchApp = (id) =>
  axiosInstance().get(`/integrations/${id}`)
    .then(response => response.data)

export const fetchApps = () =>
  axiosInstance().get('/integrations')
    .then(response => response.data)

export const createApp = () =>
  axiosInstance().post('/integrations')
    .then(response => response.data)

export const getAppAuthorization = (id) =>
  axiosInstance().get(`/integrations/${id}/authorization`)
    .then(response => response.data)

export const refreshClientSecret = (appId) =>
  axiosInstance().post(`integrations/${appId}/client_secret/refresh`)
    .then(response => response.data)

export const refreshVerificationToken = (appId) =>
  axiosInstance().get(`integrations/${appId}/verification_token/refresh`)
    .then(response => response.data)

export const fetchAppRedirectUrl = (appId) =>
  axiosInstance().get(`/integrations/${appId}/authorization`)
    .then(response => response.data)
    .then(data => data.redirectUris[0])

export const fetchAppRedirectUrls = (appId) =>
  axiosInstance().get(`/integrations/${appId}/authorization`)
    .then(response => response.data)
    .then(data => data.redirectUris)

export const updateAppRedirectUrls = ({ redirectUris, appId }) => {
  const payload = { redirectUris }

  return axiosInstance().patch(`/integrations/${appId}/authorization`, payload)
    .then(response => response.data)
    .then(data => data.redirectUris)
}

export const fetchEvents = (appId) =>
  axiosInstance().get(`/integrations/${appId}/events`)
    .then(response => response.data)

export const fetchEventDescriptions = () =>
  axiosInstance().get('/events')
    .then(response => response.data)

export const updateEventRequestUrl = ({ requestUrl, appId }) => {
  const payload = { requestUrl }
  return axiosInstance().patch(`/integrations/${appId}/events`, payload)
}

export const testEventRequestUrl = ({ requestUrl }) => {
  const payload = { url: requestUrl }
  return axiosInstance().post(`/integrations/event-hook-test`, payload);
}

export const updateEventSubscriptions = ({ appId, subscriptions }) => {
  const payload = { subscriptions }
  return axiosInstance().patch(`/integrations/${appId}/events`, payload)
}

export const deleteApplication = (appId) =>
  axiosInstance().delete(`/integrations/${appId}`)

export const updateIconUrl = ({ iconUrl, appId }) => {
  const payload = { iconUrl }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateAppName = ({ name, appId }) => {
  const payload = { name }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateExternalUrlEnabled = ({ externalUrlEnabled, appId }) => {
  const payload = { externalUrlEnabled }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateExternalUrl = ({ externalUrl, appId }) => {
  const payload = { externalUrl }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateAppShortDescription = ({ shortDescription, appId }) => {
  const payload = { shortDescription }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateAppLongDescription = ({ longDescription, appId }) => {
  const payload = { longDescription }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateAppCategory = ({ category, appId }) => {
  const payload = { category }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const updateAppPricing = ({ paidStatus, appId }) => {
  const payload = { paidStatus }

  return axiosInstance().patch(`/integrations/${appId}`, payload)
    .then(response => response.data)
}

export const installAppToDrift = (appId) =>
  axiosInstance().post(`/integrations/${appId}/install`)
    .then(response => response.data.token)

export const uninstallAppFromDrift = (appId) =>
  axiosInstance().post(`/integrations/${appId}/uninstall`)
    .then(response => undefined)

export const fetchAppTestToken = (appId) =>
  axiosInstance().get(`/integrations/${appId}/install`)
    .then(response => response.data.token)

export const fetchAppScopes = (appId) =>
  axiosInstance().get(`/integrations/${appId}/authorization`)
    .then(response => response.data.scopes)

export const updateAppScopes = ({ appId, scopes }) => {
  const payload = { scopes }

  return axiosInstance().patch(`/integrations/${appId}/authorization`, payload)
    .then(response => response.data.groups)
}

export const fetchAppScopeDescriptions = () =>
  axiosInstance().get('/scopes/groups')
    .then(response => response.data.groups)

export const fetchAppSubmissionData = (appId) =>
  axiosInstance().get(`/integrations/${appId}/submission`)
    .then(response => response.data)

export const updateTermsOfServiceFlag = ({ appId, agreesToTermsOfService }) => {
  const payload = { agreesToTermsOfService }

  return axiosInstance().patch(`/integrations/${appId}/submission`, payload)
    .then(response => response.data)
}

export const updateSecurityReviewFlag = ({ appId, agreesToSecurityReview }) => {
  const payload = { agreesToSecurityReview }

  return axiosInstance().patch(`/integrations/${appId}/submission`, payload)
    .then(response => response.data)
}

export const updateSubmissionNotes = ({ appId, submissionNotes }) => {
  const payload = { submissionNotes }

  return axiosInstance().patch(`/integrations/${appId}/submission`, payload)
    .then(response => response.data)
}

export const submitAppForReview = (appId) =>
  axiosInstance().post(`/integrations/${appId}/submit`)
    .then(response => response.data)

export const publishApp = (appId) =>
  axiosInstance().post(`/integrations/${appId}/publish`)
    .then(response => response.data)
